<div soho-widget
    widgetHeight="{{panel.widgetHeight}}"
    widgetWidth="{{panel.widgetWidth}}"
    attr.data-automation-id="lm-{{panel.automationId}}-widget"
>

  <div soho-widget-header>
    <h2 soho-widget-title
        tabIndex="0"
        [ngStyle]="{'display': 'inline-block'}"
        [ngClass]="{'hasOverviewClass': (hasOverviewNavigation && displayLinkAsText) }"
        soho-tooltip [content]="panel.title"
        attr.id="{{panel.id}}_widget_title"
        attr.data-automation-id="lm-{{panel.automationId}}-widget-title"
    >{{panel.title}}</h2>

    <div class="panelNavigation">
      <button *ngIf="hasOverviewNavigation && !displayLinkAsText"
          soho-button="icon"
          icon="right-arrow"
          soho-tooltip [content]="overNavigationLink"
          (click)="onNavigationClick($event)"
          attr.id="{{panel.id}}_overview_navigation"
          attr.data-automation-id="lm-{{panel.automationId}}-overview-navigation"
      ></button>
      <a *ngIf="hasOverviewNavigation && displayLinkAsText"
          soho-hyperlink
          attr.aria-label="{{panel.title}} - {{overNavigationLink}}"
          [attr.tabindex]="isInAccessibilityMode ? 0 : null"
          class="lm-hyperlink"
          (click)="onNavigationClick($event)"
          (keydown.enter)="onNavigationClick($event)"
          attr.id="{{panel.id}}_overview_navigation"
          attr.data-automation-id="lm-{{panel.automationId}}-overview-navigation"
      >{{overNavigationLink}}</a>
    </div>
  </div>

  <div soho-widget-content [innerHtml]="columnInfo | safe" (click)="onWidgetContentClick($event)"></div>
</div>
